__webpack_require__.p = "https://beta-eu-west-1.arms-registration.pace.amazon.dev/";